import { useLang, useSeo } from '@/i18n/LanguageContext';
import PageHero from '@/components/PageHero';
import { Reveal } from '@/components/Reveal';

export default function Legal({ kind }) {
  const { content } = useLang();
  const doc = content.legal[kind];
  useSeo(`${doc.title} | Rodotrack`, doc.intro);

  return (
    <>
      <PageHero badge={content.legal.privacy.title === doc.title ? content.legal.privacy.title : content.legal.terms.title} title={doc.title} subtitle={doc.updated} />
      <section className="py-14 lg:py-20" data-testid="legal-section">
        <div className="container-x max-w-3xl">
          <Reveal>
            <p className="text-[15px] font-medium leading-relaxed text-brand-navy/90">{doc.intro}</p>
          </Reveal>
          <div className="mt-10 space-y-9">
            {doc.sections.map((s, i) => (
              <Reveal key={i} delay={Math.min(i * 0.04, 0.3)}>
                <div data-testid={`legal-section-${i}`}>
                  <h2 className="font-display text-lg font-bold text-brand-navy sm:text-xl">{s.h}</h2>
                  {s.p.map((p, j) => (
                    <p key={j} className="mt-3 text-[14.5px] leading-relaxed text-brand-muted">{p}</p>
                  ))}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}